import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Post } from '../post.model';
import { ActivatedRoute, Router } from '@angular/router';
import { DoggogramService } from '../doggogram.service';
import { AuthService } from 'src/app/auth/auth.service';
import { AlertController, ModalController } from '@ionic/angular';
import { CommentsModalComponent } from 'src/app/shared/comments-modal/comments-modal.component';

@Component({
  selector: 'app-post',
  templateUrl: './post.page.html',
  styleUrls: ['./post.page.scss'],
})
export class PostPage implements OnInit {
  postSub: Subscription;
  userSub: Subscription;
  isLoading = true;
  userId = 0;
  post: Post;
  postId = 0;
  constructor(
    private activatedRoute: ActivatedRoute,
    private doggogramService: DoggogramService,
    private authService: AuthService,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private router: Router
  ) { }

  ViewComments(postid: number, postUserId: number) {
    if (this.userId <= 0) {
      this.ShowLoginAlert();
      return;
    }
    this.modalCtrl
      .create({
        component: CommentsModalComponent,
        componentProps: {
          postid,
          postUserId,
          userId: this.userId,
          source: 'doggogram',
        },
      })
      .then((modalEl) => {
        modalEl.onDidDismiss().then((modalData) => {
          if (!modalData.data) {
            return;
          }
          this.post.commentsCount = modalData.data['commentsCount'];
        });
        modalEl.present();
      });
  }

  ShowLoginAlert() {
    this.alertCtrl
      .create({
        header: 'Sign In Reqiured',
        message: 'You need to sign in first to view or add comments',
        buttons: [
          {
            text: 'Dismiss',
            handler: () => {
              this.alertCtrl.dismiss();
            },
          },
          {
            text: 'Sign in',
            handler: () => {
              this.router.navigateByUrl('/signin');
            },
          },
        ],
      })
      .then((alertEl) => alertEl.present());
  }
  async ngOnInit() {
    this.postId = +this.activatedRoute.snapshot.params.id;
    this.userId = await this.authService.getUserId();
    this.postSub = this.doggogramService
      .getPostById(this.userId, this.postId)
      .subscribe((post) => {
        this.post = post;
        this.isLoading = false;
        const openComment =
          this.activatedRoute.snapshot.queryParams['openComment'];
        if (openComment == 'true') {
          this.ViewComments(this.post.id, this.post.userid);
        }
      });
  }

  ngOnDestroy() {
    if (this.postSub) {
      this.postSub.unsubscribe();
    }
  }
}
